import { Box, Card, CardActions, CardContent, Container, Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { EWasteRequestDetails, EwasteProduct } from 'src/interfaces/repair-request/e-waste-request';
import { ToolTipView } from 'src/components/tooltip';
import { format } from 'date-fns';
import { getEWasteStatusColor, getStatusColor } from 'src/components/masters/customFunctions';

interface CustomerTabPanelProps{
  requestLists: EWasteRequestDetails[];
  tabValue: string;
}

export default function RequestList({ requestLists, tabValue }: CustomerTabPanelProps) {
  const renderStatus = (status) => {
    const color = tabValue === '2' ? getStatusColor(status) : getEWasteStatusColor(status);
    return (
      <Container
        disableGutters
        sx={{
          m: 0,
          px: 0,
          color: `${color}`,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center'
        }}
      >
        <Box
          sx={{
            backgroundColor: `${color}`,
            borderRadius: '50%',
            height: 12,
            width: 12,
            ml: 0,
            my: 1,
            mr: 1
          }}
        />
        {status}
      </Container>
    );
  };
  // this method creates a list which show on tooltip
  const getReducedArray = (productArray: EwasteProduct[]) => {
    let i = 1;
    const modifiedStringArray: string[] = [];
    while (i < productArray.length) {
      modifiedStringArray.push(productArray[i++].name);
    }
    return modifiedStringArray;
  };
  const tableColumns = [
    {
      id: 'id',
      label: 'Request ID',
      sortDisable: false
    },
    {
      id: 'productName',
      label: 'Product Name',
      sortDisable: false
    },
    {
      id: 'cpName',
      label: 'Channel Partner Name',
      sortDisable: false
    },
    {
      id: 'tcName',
      label: tabValue === '2' ? 'Technician Name' : 'Collection Agent Name',
      sortDisable: false
    },
    {
      id: 'createdAt',
      label: 'Booking Date',
      sortDisable: false
    },
    {
      id: 'appointmentDate',
      label: 'Appointment Date',
      sortDisable: false
    },
    {
      id: 'status',
      label: 'Status',
      sortDisable: false
    }
  ];
  const noRequestMessage = () => (
    <Typography
      variant="h6"
      pl={1}
    >
      No Request Available
    </Typography>
  );
  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        flexGrow: 1,
        m: 0,
        pt: 1
      }}
    >
      <Card
        variant="outlined"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1
        }}
      >
        <CardContent
          sx={{
            p: 0
          }}
        >
          <Box>
            {requestLists?.length > 0 ? (
              <TableContainer
                sx={{
                  maxHeight: '400px',
                }}
              >
                <Table
                  stickyHeader
                  size="small"
                  sx={{
                    border: 1,
                    borderColor: '#e1e3ea',
                    borderRadius: '2px',
                  }}
                >
                  <TableHead>
                    <TableRow>
                      {tableColumns.map((column) => (
                        <TableCell
                          key={column.id}
                          sx={{
                            backgroundColor: 'neutral.100',
                          }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {requestLists?.map((WasteReq) => (
                      <TableRow
                        hover
                        key={WasteReq.id}
                      >
                        <TableCell
                          align="left"
                        >
                          <Link
                            color="primary"
                            component={RouterLink}
                            sx={{ display: 'block' }}
                            to={`/dashboard/ewaste-request/view/${WasteReq.id}`}
                            underline="none"
                            variant="subtitle2"
                          >
                            {WasteReq.id}
                          </Link>
                        </TableCell>
                        <TableCell
                          align="justify"
                        >
                          {WasteReq.products[0].name || 'N/A'}
                          { WasteReq.products.length > 1 && (
                          <ToolTipView
                            tooltips={getReducedArray(WasteReq.products)}
                            label={`+${WasteReq.products.length - 1}`}
                          />
                          )}
                        </TableCell>
                        <TableCell align="justify">
                          {WasteReq?.assignee?.channelPartnerId ? WasteReq.assignee.channelPartnerName : 'N/A'}
                        </TableCell>
                        <TableCell
                          align="justify"
                        >
                          {WasteReq?.assignee?.technicianId ? WasteReq.assignee.technicianName : 'N/A'}
                        </TableCell>
                        <TableCell
                          align="left"
                        >
                          {WasteReq?.createdAt ? format(new Date(WasteReq?.createdAt), 'MMM dd, yyyy') : 'N/A'}
                        </TableCell>
                        <TableCell
                          align="left"
                        >
                          {WasteReq?.appointmentSlot?.date ? format(new Date(WasteReq.appointmentSlot.date), 'MMM dd, yyyy') : 'N/A'}
                        </TableCell>
                        <TableCell>
                          {renderStatus(WasteReq.status)}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              noRequestMessage()
            )}
          </Box>
        </CardContent>
        <CardActions
          sx={{
            p: 0
          }}
        />
      </Card>
    </Box>
  );
}
